import { useFilterSchema } from 'hooks/useFilterSchema'
import { useSelector } from 'react-redux'
import { Variables } from 'reducers/filtering/selectors'
import { RootState } from 'reducers/store'
import { selectUserSubscription } from 'reducers/subscription/selectors'
import { Cell } from 'reducers/subscription/user'
import { Filter } from 'typings/filters'
import { mapFiltersWithValues, generateCombinationSet, hasMatch } from 'util/validateContext'
import { useEffect, useState } from 'react'

export const useValidateContext = (
  productSelectedFilters: Filter[],
  countrySelectedFilters: Filter[]
) => {
  const [validContext, setValidContext] = useState(true)
  const context = useSelector((state: RootState) => selectUserSubscription(state))
  const { filterSchema } = useFilterSchema()
  const countryAnswers = useSelector(
    (state: RootState) => state.filters.filterValues[Variables.COUNTRY.toString() + filterSchema]
  )
  const productGroupsAnswers = useSelector(
    (state: RootState) =>
      state.filters.filterValues[Variables.PRODUCT_GROUP.toString() + filterSchema]
  )

  useEffect(() => {
    const productFilters = mapFiltersWithValues(
      productSelectedFilters,
      Variables.PRODUCT_GROUP,
      productGroupsAnswers
    )
    const marketFilters = mapFiltersWithValues(
      countrySelectedFilters,
      Variables.COUNTRY,
      countryAnswers
    )
    const combinationSet = generateCombinationSet(productFilters, marketFilters)
    const isValid = hasMatch(combinationSet, context as Cell[]) ?? true
    setValidContext(isValid)
  }, [productSelectedFilters, countrySelectedFilters, context, filterSchema])

  return {
    validContext,
  }
}
